// extracted by mini-css-extract-plugin
module.exports = {"loginBlock":"Login_loginBlock__1HJjj","loginBlockLogo":"Login_loginBlockLogo__2zstg","spin":"Login_spin__2zXaZ"};